import { render, staticRenderFns } from "./AssetViewModal.vue?vue&type=template&id=38d1b042"
import script from "./AssetViewModal.vue?vue&type=script&lang=js"
export * from "./AssetViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports